// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"446":"90821b92","831":"6e52404f"}[chunkId] + ".chunk.js";
};